export enum ModalResources {
  RESOURCES = 'Digital Resources',
  ASSESSMENTS = 'Paper Assessments Responses',
}
